var LMApplicationRedirectModule = function LMApplicationRedirectModule(validationText) {
    var modalDivString = '<div class="modal fade" id="sfappModal" tabindex="-1" role="dialog" aria-labelledby="sfapp-modal"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header"><button id= "sfappBtnClose" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body">' + validationText.NoCar.Text + '</div><div class="modal-footer"><button id="sfappBtnVisitPul" type="button" class="btn btn-lm-white margin-right">' + validationText.NoCar.VisitPersonalButton + '</button><button id="sfappBtnBack" type="button" class="btn btn-lm margin-left" data-dismiss="modal">' + validationText.NoCar.IHaveCarButton + '</button></div></div></div></div>';
    var duplicateLeadModalDivString = '<div class="modal fade" id="duplicateleadModal" tabindex="-1" role="dialog" aria-labelledby="duplicatelead-modal"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header"><button id="duplicateleadModalBtnClose" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body">' + validationText.DuplicateLeadText + '</div></div></div></div>';
    var thirdPartyModalDivString = '<div class="modal fade" id="thirdPartyModal" tabindex="-1" role="dialog" aria-labelledby="thirdParty-modal" data-backdrop="static" data-keyboard="false"> \
                                        <div class="modal-dialog" role="document"> \
                                            <div class="modal-content"> \
                                                <div class="modal-header"> \
                                                    <button id="thirdPartyModalBtnClose" type="button" class="close third-party-close"  aria-label="Close"> \
                                                        <span aria-hidden="true">&times;</span></button> \
                                                </div> \
                                                <div class="modal-body"> \
                                                    <p>Good News, we have a solution for you! Although LoanMart does not provide title loans in <span class="third-party-state"></span>,  \
                                                        <span class="third-party-dynamic-text1"></span><span class="thirdPartyReferName"></span> can help!</p>  \
                                                    <p class="third-party-dynamic-text2">They are one of the <strong>highest rated Title Loan Processing Centers</strong> in the country, according to ConsumerAffairs.com.</p> \
                                                    <p>Please <a id="thirdPartyReferUrlBtn" href="#">click here</a> to <span class="third-party-dynamic-text3"></span> <span class="thirdPartyReferName"></span> or you will be redirected to their website in 10 seconds.</p> \
                                                    <p>If <span class="third-party-state"></span> is not your state of of residence, please <a id="thirdPartyBack" href="#" class="third-party-close" >click here</a> to cancel and update your state.</p> \
                                                    <p>Thank you for visiting LoanMart</p> \
                                                </div> \
                                            </div> \
                                        </div> \
                                     </div>';

    var appRedirectDiv = $('.applicationredirect-module');
	var redirectDivFound = false;
    if (appRedirectDiv) {
        //appRedirectDiv.closest('.section')
        //.attr('id', 'Hero');

        $(modalDivString)
        .insertAfter('#Hero');

        $(duplicateLeadModalDivString)
        .insertAfter('#Hero');

        $(thirdPartyModalDivString)
       .insertAfter('#Hero');

		redirectDivFound = true;
    }

    var basicAppRedirectDiv = $('.applicationredirect-module-basic');
    if (basicAppRedirectDiv && !redirectDivFound) {
        //basicAppRedirectDiv.closest('.section')
        //.attr('id', 'hero-basic');

        $(modalDivString)
        .insertAfter('#hero-basic');

        $(duplicateLeadModalDivString)
        .insertAfter('#hero-basic');

        $(thirdPartyModalDivString)
        .insertAfter('#hero-basic');
    }    

    $.when(window.defFormLogic).done(function () {
        $('#getStartedForm').formValidation({
            framework: 'bootstrap',
            fields: {
                firstName: {
                    row: '.col-md-6',
                    validators: {
                        notEmpty: {
                            message: validationText.FirstNameNotSpecified
                        },
                        regexp: {
                            regexp: /^(?=.{1,35}$)[a-zA-Z]+[a-zA-Z\-\s\.']*$/,
                            message: validationText.FirstNameCharacterWarning
                        }
                    }
                },
                lastName: {
                    row: '.col-md-6',
                    validators: {
                        notEmpty: {
                            message: validationText.LastNameNotSpecified
                        },
                        regexp: {
                            regexp: /^(?=.{1,35}$)[a-zA-Z]+[a-zA-Z\-\s\.']*$/,
                            message: validationText.LastNameCharacterWarning
                        }
                    }
                },
                email: {
                    row: '.email',
                    validators: {
                        notEmpty: {
                            message: validationText.EmailNotSpecified
                        },
                        regexp: {
                            regexp: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
                            message: validationText.EmailInvalid
                        }
                    }
                },
                state: {
                    row: '.state',
                    validators: {
                        notEmpty: {
                            message: validationText.SelectState
                        }
                    }
                },
                car: {
                    row: '.car',
                    validators: {
                        notEmpty: {
                            message: validationText.SelectCar
                        }
                    },
                    onSuccess: function (e, data) {
                        data.fv.revalidateField('email');
                    }
                },
    			promocode: {
    				row: '.promocode',
    				validators: {}
    			},
                terms: {
                    row: '.terms',
                    validators: {
                        notEmpty: {
                            message: validationText.SelectTerms
                        }
                    }
                },
                eSignConsent: {
                    row: '.eSignConsent',
                    validators: {
                        notEmpty: {
                            message: validationText.SelectESignConsent
                        }
                    }
                }
            }
        })
    });
}
